// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Banner-cls1__ee9438d914ac31ceded9{/*!*/}.Banner-cls2___36801dea53f1d27b216{display:flex;align-items:center;justify-content:flex-end;grid-gap:12px;gap:12px;flex-basis:100%}@media(min-width: 375px){.Banner-cls2___36801dea53f1d27b216{flex-basis:auto}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Banner-cls1__ee9438d914ac31ceded9",
	"cls2": "Banner-cls2___36801dea53f1d27b216 Banner-cls1__ee9438d914ac31ceded9"
};
export default ___CSS_LOADER_EXPORT___;
